export default {
    ROLES: {
        MANAGER: 'ROLE_MANAGER',
        ADMIN: 'ROLE_ADMIN',
        CALLER: 'ROLE_CALLER'
    }
}